// extracted by mini-css-extract-plugin
module.exports = {"footer_in_board":"style_footer_in_board__qY71w","overrideCascader":"style_overrideCascader__zT5vT"};